import * as s from "../CommonStyled";
import { Text } from "components/atoms/text/Text";
import VideoThumbnail from "components/atoms/image/thumbnail/VideoThumbnail";
import ProtectedThumbnail from "components/atoms/image/thumbnail/ProtectedThumbnail";

type DualProps = {
  //data: DualModeLivefeedType;
  data: {
    name: string;
    videoLoss: boolean;
    thumbnailUrl: string;
    permission: boolean;
  };
  columns: number;
  isProtected: boolean;
};

const LivefeedItem = (props: DualProps): JSX.Element => {
  return (
    <s.LivefeedItem>
      {props.isProtected ? (
        <ProtectedThumbnail />
      ) : (
        <VideoThumbnail
          videoLoss={!props.data.videoLoss}
          thumbnailUrl={props.data.thumbnailUrl}
          isNoPermission={!props.data.permission}
        />
      )}
      <s.LiveRow>
        <s.Circle status={props.data.videoLoss} />
        <s.LivefeedColumn>
          <Text bold fontSize={10}>
            {props.data.name}
          </Text>
        </s.LivefeedColumn>
      </s.LiveRow>
    </s.LivefeedItem>
  );
};

export default LivefeedItem;
